<template>
    <div class='myArea'>
        <div class='q-pa-xs q-ml-lg q-mr-lg main_line row no-wrap justify-between items-center'>
            <div class='row no-wrap items-center'>
                <q-btn icon='clear' round dense flat color='negative' @click='deleteFileFromUpload'/>
                <div class='q-body-1 q-ml-md'>{{ fileName }}</div>
            </div>
            <div class='q-body-2 q-mr-md'>
                {{fileSize}}
            </div>
        </div>


    </div>


</template>

<script>
/* eslint-disable */



export default {
    props:{
            fieldData : {
                type : File,
                required : true,
            }

    },
    components :{

    },

    data () {
        return {
        }
    },

  
    created(){ 

    },

    computed : {

        fileData : {
            get: function() {
                return this.fieldData.fileData;
            },
            set: function (newValue) {
                this.fieldData.fileData = newValue;
            }
        },

        upLoadFile() {
            return this.fileData.file
        },
       
        loaded: {
            get: function() {
                return this.fileLoaded;
            },
            set: function (newValue) {
                this.fileLoaded = newValue;
            }
        },


        fileName() {
            return this.fieldData.name;
        },

        fileSize() {
            // формируем удобочитаемый вовод: килобайты, мегабайты
            let q = this.fieldData.size+'';
            let result = Math.round(q/1024*100)/100 + ' kb';
            if (q.length > 5) result = Math.round(q/1024/1024*100)/100+' mb'
            return result;
        }

    },
    
    beforeDestroy () {

    },
   
    methods : {
        deleteFileFromUpload() { ///обработка события кнопки на удаление файла из списка для загрузки
            this.$store.commit('deleteFileFromUpload', this.fieldData.name); // отправляем мутацию на удаление файла. к сожалению по имени
        },
    },

}

</script>


<style lang="scss" scoped>
    .myArea{

    }
    .main_line {
        border : 1px solid rgba(1, 97, 25, 0.329);
        background: rgba(220, 255, 224, 0.678);
        margin-top : -1px;
        cursor: pointer;

        &:hover {
            background: lightgreen;
        }

    }
    .myborder {
        border : 1px solid rgb(209, 209, 209);
        &:hover {
            background: lightgreen;
        }
    }
</style>
